import type { DynamicTariff } from '@integration/api-client/tariffmanagement';
import type { UnitOfMeasurement } from '@integration/base-models';

import { EnergyType } from '../../shared/api-client-interfaces/enums';
import {
  dynamicPricesAvailabilityMock,
  dynamicPricesByDateResponseMock,
} from '../testing';
import type {
  CurrentPayload,
  DynamicPricesModel,
  SelectedHourInfo,
} from '../models';

export const dynamicPricesVM = (
  currentPayload: CurrentPayload = {
    date: '2024-03-04',
    energyType: EnergyType.ELECTRICITY,
  }
): DynamicPricesModel => ({
  entity: dynamicPricesByDateResponseMock('2024-03-04').electricity,
  currentPayload,
  availability: dynamicPricesAvailabilityMock,
  isLoading: true,
  lastLoadedDate: '2024-03-04',
  isDateError: false,
  isAvailabilityError: false,
});

export const hourInfoMock = (
  dynamicTariff?: DynamicTariff,
  unitOfMeasurement?: UnitOfMeasurement
): SelectedHourInfo => ({
  selectedTariff: dynamicTariff,
  selectedHour: 22,
  unitOfMeasurement,
  selectedEnergyType: EnergyType.ELECTRICITY,
});
